import React, { useState } from 'react';
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonLabel, IonSelect, IonSelectOption, IonButton, IonSpinner } from '@ionic/react';
import './pdfreport.css';
import getApi from '../api';

interface PdfReportCardProps {
  pumpId: string;
}

const PdfReportCard: React.FC<PdfReportCardProps> = ({ pumpId }) => {
  const [year, setYear] = useState<number | null>(null);
  const [month, setMonth] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const api = getApi();

  const handleYearChange = (event: any) => {
    setYear(event.detail.value);
  };

  const handleMonthChange = (event: any) => {
    setMonth(event.detail.value);
  };

  const handleSubmit = async () => {
    if (year && month) {
      setLoading(true);
      try {
        const response = await api.get(`/bbe/getflowreport/${pumpId}/${year}/${month}/?pdf=true`, {
          responseType: 'blob'
        });
        const blob = response.data;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `report_${pumpId}_${year}_${month}.pdf`;
        link.click();
      } catch (error) {
        console.error('Error fetching the PDF:', error);
      } finally {
        setLoading(false);
      }
    } else {
      console.log('Year and month must be selected');
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div className="overlay">
          <IonSpinner name="crescent" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
          Laddar ner PDF Rapport...
        </div>
      )}
      <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ladda ner PDF Rapport</IonCardTitle>
        </IonCardHeader>
        <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>År</IonLabel>
          <IonSelect value={year} placeholder="Välj År" onIonChange={handleYearChange} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {[2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].map((yearOption) => (
              <IonSelectOption key={yearOption} value={yearOption} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                {yearOption}
              </IonSelectOption>
            ))}
          </IonSelect>
          <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Month</IonLabel>
          <IonSelect value={month} placeholder="Välj Månad" onIonChange={handleMonthChange} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonSelectOption key="01" value="01" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Januari</IonSelectOption>
            <IonSelectOption key="02" value="02" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Februari</IonSelectOption>
            <IonSelectOption key="03" value="03" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Mars</IonSelectOption>
            <IonSelectOption key="04" value="04" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>April</IonSelectOption>
            <IonSelectOption key="05" value="05" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Maj</IonSelectOption>
            <IonSelectOption key="06" value="06" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Juni</IonSelectOption>
            <IonSelectOption key="07" value="07" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Juli</IonSelectOption>
            <IonSelectOption key="08" value="08" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Augusti</IonSelectOption>
            <IonSelectOption key="09" value="09" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>September</IonSelectOption>
            <IonSelectOption key="10" value="10" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Oktober</IonSelectOption>
            <IonSelectOption key="11" value="11" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>November</IonSelectOption>
            <IonSelectOption key="12" value="12" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>December</IonSelectOption>
          </IonSelect>
          <IonButton expand="full" onClick={handleSubmit} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ladda ner</IonButton>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default PdfReportCard;